import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../app/guards'
import { transferSearchSchema } from '../../features/finance/search'
import { TransfersPage } from '../../features/finance/transfers-page'

export const Route = createFileRoute('/_app/transfers')({
  staticData: { crumb: 'transfers' },
  validateSearch: transferSearchSchema,
  beforeLoad: ({ context }) => requirePermission(context.session, 'treasury.read'),
  component: TransfersPage,
})
